// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2ZRWS","description":"PatientConsentPreview_description__2wtDg"};